import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: '10px'
  },

  taskModal: {
    display: 'flex',
    flexFlow: 'row-reverse',
    alignItems: 'center',
    marginTop: '10px',

    '& > div > svg': {
      color: theme.palette.primary.main,
      cursor: 'pointer',
      padding: '1em 0em 1em 1em',
      fontSize: theme.size.lg,
      marginRight: '0px'
    }
  },

  icon: {
    marginRight: '10px',
    fontSize: theme.size.lg,
    color: theme.palette.primary.main,
    cursor: 'pointer',
    padding: '1rem',
    height: 20,
    width: 20
  },

  rotate: {
    transform: 'rotate(90deg)'
  },

  submit: {
    width: 'auto',
    padding: '0 1rem',
    fontSize: theme.size.sm,

    '& .icon': {
      marginRight: ({ iconLeft }) => (iconLeft ? '20px' : '0'),
      marginLeft: ({ iconLeft }) => (iconLeft ? '0' : '20px'),
      fontSize: theme.size.lg
    }
  },

  largerBtn: {
    width: '250px'
  },

  endButtons: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'flex-end',

    '& > div': {
      marginLeft: '1rem'
    },

    '& > :first-child': {
      marginRight: '0.5rem'
    },

    [theme.breakpoints.down(769)]: {
      '& button': {
        fontSize: theme.size.base
      }
    },

    [theme.breakpoints.down(451)]: {
      margin: '1rem 0',
      width: '100%',

      '& button': {
        flexBasis: '48.5%'
      },

      '& > button > .MuiButton-label': {
        fontSize: theme.size.sm
      },

      '& > div': {
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        marginTop: '0.5rem',
        marginLeft: '0',
        marginBottom: '2rem'
      }
    }
  }
}))

export default useStyles
